import React, { useContext, useEffect, useRef, useState } from 'react';
import ConferenceRoomBdy from './conferenceRoomBdy';
import '../../../style.css';
import JoinMeeting from './meetingPopup/joinMeeting';
import InstantMeeting from './meetingPopup/instantMeeting';
import callApi from '../../../libs/callApi';
import DotSpinLoader from '../../../../Loader/dotSpinLoader';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ControllerContext from '../../../../../RoomControllerSocketContext';
import { store } from '../../../../../store/store';
import * as roomActions from '../../../../../store/actions/roomActions';

const CRoomMainCrnt = (props) =>
{
	const [ meetingsList, setMeetingsList ] = useState([]);
	const [ selectedMeeting, setSelectedMeeting ] = useState(null);
	const [ userlicencedata, setData ] = useState('');
	const [ userdetails, setuserdetails ] = useState('');
	const [ isLoading, setIsLoading ] = useState(false);
	const [ meet, setMeet ]= useState('');
	const userDataSignal = useRef(null);
	const meetingsDataSignal = useRef(null);
	const navigate = useHistory();
	const { pluginSocket } = useContext(ControllerContext);

	// harish.s@instavc.com'

	const handleInstant = async () =>
	{
		try
		{
			setIsLoading(true);
			const dataforlicense = JSON.stringify({
				'path'     : `${import.meta.env.VITE_AUTH_API_GET_USER_PATH}/getmylicense`,
				'method'   : 'GET',
				'apiQuery' : `email=${encodeURIComponent(`${userdetails?.data?.email}`)}`
			});
			const licencedata = await callApi(dataforlicense);

			if (licencedata.length===0)
			{
				console.log('no license=====');
				toast.error('Your License is Expired');
				setIsLoading(false);
			}
			else
			{
				console.log('my license/////', licencedata);
				// const userResponse = await callApi(dataforuserdetails);

				console.log('my user data======', userdetails);
				setData(licencedata);
				// setuserdetails(userResponse);
				setIsLoading(false);
				setMeet('InstantMeet');
			}
		}
		catch (error)
		{
			console.error('Error occurred:', error);
			setIsLoading(false);
		}
	};

	const handleCloseMeet = () =>
	{
		setMeet('');
	};

	useEffect(() =>
	{

		// async function getRoomData()
		// {
		// 	const roomIdData = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomId');

		// 	if (roomIdData)
		// 	{
		// 		setRoomId(roomIdData);
		// 	}
		// }
		// getRoomData();
		const fetchData = async () =>
		{
			setIsLoading(true);
			try
			{

				const dataforuserdetails = JSON.stringify({
					'path'   : `${import.meta.env.VITE_AUTH_API_GET_USER_PATH}/getUserDetails`,
					'method' : 'GET'
				});

				if (userDataSignal.current)
				{
					userDataSignal.current.abort();
				}

				userDataSignal.current = new AbortController();

				const userResponse = await callApi(dataforuserdetails, userDataSignal.current.signal);

				userDataSignal.current = null;
				setuserdetails(userResponse);
				if (userResponse?.data?.email)
				{
					localStorage.setItem('userEmail', userResponse?.data?.email);
				}
				getMeetings(userResponse.data);
			}
			catch (error)
			{
				console.log(error);
				setIsLoading(false);
				userDataSignal.current = null;
			}
		};

		fetchData();
	}, [ props?.refresh ]);

	useEffect(() =>
	{
		pluginSocket?.on('startMeeting', async (meetingData) =>
		{
			console.log('isekfenla/...............', meetingData);
			store.dispatch(roomActions.setRoomType(meetingData?.scheduleType));
			store.dispatch(roomActions.setSessionName(meetingData?.meetingName));
			const meetingType = btoa(meetingData?.scheduleType);

			const uid = localStorage.getItem('userEmail') ? btoa(localStorage.getItem('userEmail')) : btoa(userdetails?.data?.email);

			let displayName;

			if (meetingData?.displayName)
			{
				displayName = btoa(meetingData?.displayName);
			}
			else
			{
				displayName = btoa(userdetails?.data?.firstName);
			}

			const profileImg=userdetails?.data?.profileImage?.key ? encodeURIComponent(userdetails?.data?.profileImage?.key) : '';

			const { controllerUniqueId, desktopUniqueId } = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');

			// eslint-disable-next-line prefer-template
			const meetingPath = '/' + meetingData?.sessionId + '?projectId=' + import.meta.env.VITE_ProjectId + '&uid=' + uid + '&displayName=' + displayName + '&meetingType=' + meetingType + '&pairId=' + desktopUniqueId + '_' + controllerUniqueId + '&profileKey=' + profileImg;

			pluginSocket?.emit('joiningStatus', { status: true });
			navigate.push(meetingPath);

		});

		return () =>
		{
			pluginSocket?.off('startMeeting');
		};

	}, [ pluginSocket, userdetails ]);

	async function getMeetings(data)
	{

		try
		{
			const endTime = new Date();

			endTime.setHours(23, 59, 59, 999);
			const meetingData = JSON.stringify({
				'path'    : '/schedule/replicategetmeetingsbetween',
				'method'  : 'POST',
				'apiBody' : {
					'currentTime' : new Date().valueOf(),
					'endTime'     : new Date(endTime).valueOf(),
					'email'       : `${data?.email}`
				}
			});

			if (meetingsDataSignal.current)
			{
				meetingsDataSignal.current.abort();
			}

			meetingsDataSignal.current = new AbortController();

			const meetingsResponse = await callApi(meetingData, meetingsDataSignal.current.signal);

			console.log('meetingsResponse==', meetingsResponse);
			meetingsDataSignal.current = null;
			if (meetingsResponse?.length > 0)
			{
				setMeetingsList(meetingsResponse);
				setSelectedMeeting(meetingsResponse?.[0]);
			}
			else
			{
				setMeetingsList([]);
				setSelectedMeeting(null);
			}
			setIsLoading(false);
		}
		catch (error)
		{
			console.log('error in get today meetings===', error);
			setIsLoading(false);
			meetingsDataSignal.current = null;
		}

	}

	return (
		<>
			{meetingsList?.length <= 0 ?
				<div className='flexRow conferenceRoomContainer aCntr jCntr'>
					<div className='flexAutoCol pdng60 aCntr' onClick={() => setMeet('JoinMeet')}>
						<div className='iconBrdr'>
							<div className='confBtn joinMtngbtn'>
								<img
									src='/icons/joincopy.svg'
									alt='instant_meeting'
									className='dImg1'
								/>
							</div>
						</div>
						<small className='pdngTMD hdingWLG'>
							Join Meeting
						</small>
					</div>
					<div className='flexAutoCol pdng60 aCntr' onClick={handleInstant}>
						<div className='iconBrdr'>
							<div className='confBtn instantMtngBtn'>
								<img
									src='/icons/instant.svg'
									alt='instant_meeting'
									className='dImg1'
								/>
							</div>
						</div>
						<small className='pdngTMD hdingWLG'>
							Instant Meeting
						</small>
					</div>
				</div>
				:
				<ConferenceRoomBdy
					setMeet={setMeet}
					handleInstant={handleInstant}
					setSelectedMeeting={setSelectedMeeting}
					selectedMeeting={selectedMeeting}
					userdetails={userdetails}
					meetingsList={meetingsList}
				/>
			}
			{meet === 'JoinMeet' && <JoinMeeting setIsLoading={setIsLoading} handleCloseMeet={handleCloseMeet} setMeet={setMeet} userdetails={userdetails}/>}
			{meet === 'InstantMeet' && <InstantMeeting setIsLoading={setIsLoading} handleCloseMeet={handleCloseMeet} setMeet={setMeet} data={userlicencedata} userdetails={userdetails}/>}
			{isLoading && <DotSpinLoader/>}
		</>
	);
};

export default CRoomMainCrnt;